import {GroupAvatar, Member, Membership, UserAvatar} from "@/lib/types";
import Page from "@/lib/components/Page";
import ErrorPage from "@/lib/components/ErrorPage";
import SpinnerPage from "@/lib/components/SpinnerPage";
import Header from "@/lib/components/Header";
import Nav from "@/lib/components/Nav";
import NavButton from "@/lib/components/NavButton";
import {useState} from "react";
import {useGroup} from "@/lib/components/GroupProvider";
import AvatarModal from "@/lib/components/AvatarModal";
import useCrossTabNavigation from "@/lib/crosstab";
import MemberTable from "@/lib/components/MemberTable";

class Segmentation {
    members: Member[];
    invited: Member[];
    solicitors: Member[];
    blocked: Member[];

    constructor(members: Member[]) {
        this.members = members.filter(p => (
            p.status === Membership.ADMINISTRATOR ||
            p.status === Membership.MODERATOR ||
            p.status === Membership.MEMBER
        ));
        this.invited = members.filter(p => p.status === Membership.INVITED);
        this.solicitors = members.filter(p => p.status === Membership.SOLICITOR);
        this.blocked = members.filter(p => p.status === Membership.BLOCKED);
    }
}

export default function ParticipantsPage() {
    const {navigate} = useCrossTabNavigation();

    const [avatarPreview, setAvatarPreview] = useState<UserAvatar | GroupAvatar | null>(null);

    const {group, groupLoading, groupError} = useGroup();

    if (groupError) {
        return <ErrorPage error={groupError}/>
    } else if (groupLoading || !group) {
        return <SpinnerPage/>
    }

    const parts = new Segmentation(group.members);

    const editCallback = (username: string) => {
        if (group.permissions.moderate) {
            return () => {
                navigate(`/s/${group.group_id}/members/${username}`)
            };
        } else {
            return undefined;
        }
    }

    const avatarCallback = (avatar: UserAvatar | GroupAvatar) => {
        setAvatarPreview(avatar);
    };

    const clearAvatar = () => {
        setAvatarPreview(null);
    }

    const userAvatarPreview = avatarPreview as UserAvatar;
    //const groupAvatarPreview = avatarPreview as GroupAvatar;

    return (
        <Page scrollable={true}>
            {userAvatarPreview && <AvatarModal avatar={userAvatarPreview} visible={!!avatarPreview} onRequestClose={clearAvatar}/>}

            {group.permissions.invite &&
                <Nav vertical={true} style={{marginBottom: 8}}>
                    <NavButton title={"Inviter bekjente"}
                               icon={"relation"}
                               href={`/s/${group.group_id}/invite`}/>
                </Nav>
            }
            {parts.members.length > 0 && (
                <>
                    <Header title={`Medlemmer ( ${parts.members.length} )`}/>
                    <MemberTable members={parts.members}
                                      onEdit={editCallback}
                                      onPress={avatarCallback}
                                      color={group.color}
                                      contrastColor={group.contrast_color}
                                      colored={true}/>
                </>
            )}
            {parts.solicitors.length > 0 && (
                <>
                    <Header title={`Ber om invitasjon ( ${parts.solicitors.length} )`}/>
                    <MemberTable members={parts.solicitors}
                                      onEdit={editCallback}
                                      onPress={avatarCallback}
                                      color={group.color}
                                      contrastColor={group.contrast_color}
                                      colored={false}/>
                </>
            )}
            {parts.invited.length > 0 && (
                <>
                    <Header title={`Invitert ( ${parts.invited.length} )`}/>
                    <MemberTable members={parts.invited}
                                      onEdit={editCallback}
                                      onPress={avatarCallback}
                                      color={group.color}
                                      contrastColor={group.contrast_color}
                                      colored={false}/>
                </>
            )}
            {parts.blocked.length > 0 && (
                <>
                    <Header title={`Blokkert ( ${parts.blocked.length} )`}/>
                    <MemberTable members={parts.blocked}
                                      onEdit={editCallback}
                                      onPress={avatarCallback}
                                      color={group.color}
                                      contrastColor={group.contrast_color}
                                      colored={false}/>
                </>
            )}
        </Page>
    )
}